import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store, { SESSION_ACTIVE_KEY } from './store'
import './assets/dashboard.css'
import { initAuthenticatedSession } from './services/sessionInit'
import { updateAvailability } from './composables/useAvailability'

/**
 * sessionStorage sobrevive a um F5 mas é limpo pelo navegador ao fechar a
 * aba/janela — se existe usuário salvo no localStorage (persiste sempre) mas
 * a aba atual não tem o flag de sessão ativa, é porque o navegador/aba foi
 * fechado desde o último acesso: trata como logout em vez de restaurar.
 */
function checkStaleSession() {
  let raw: string | null = null
  try {
    raw = localStorage.getItem('auth_user')
    if (!raw || sessionStorage.getItem(SESSION_ACTIVE_KEY)) return false
  } catch { return false }

  try {
    const u = JSON.parse(raw)
    if (u?.wootdash_token) {
      updateAvailability(u.wootdash_token, 'offline').catch(() => { /* melhor esforço */ })
    }
  } catch { /* usuário salvo corrompido — só limpa mesmo */ }

  localStorage.removeItem('auth_user')
  localStorage.removeItem('auth_team_ids')
  return true
}

async function bootstrap() {
  if (!checkStaleSession()) {
    store.dispatch('restoreSession')
  }
  const restoredUser = store.getters.authUser
  if (restoredUser) {
    // Fase 4.3 do plano de otimização de login (docs/planos/PLANO-OTIMIZACAO-LOGIN.md):
    // extraído pra services/sessionInit.ts — mesmo caminho que a Fase 4.4 vai
    // reaproveitar direto do login ao vivo, quando o reload sumir.
    await initAuthenticatedSession(restoredUser)
  }
  createApp(App).use(store).use(router).mount('#app')
}

bootstrap()
